const numberList = [
    {
        countryCode: "US",
        countryName: "United States of America",
        internationalPhonePrefix: "+1",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "CA",
        countryName: "Canada",
        internationalPhonePrefix: "+1",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "GB",
        countryName: "United Kingdom",
        internationalPhonePrefix: "+44",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "AF",
        countryName: "Afghanistan",
        internationalPhonePrefix: "+93",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AX",
        countryName: "Aland Islands",
        internationalPhonePrefix: "+358",
        minLength: 7,
        maxLength: 12,
    },
    {
        countryCode: "AL",
        countryName: "Albania",
        internationalPhonePrefix: "+355",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "DZ",
        countryName: "Algeria",
        internationalPhonePrefix: "+213",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AS",
        countryName: "American Samoa",
        internationalPhonePrefix: "+1-684",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "AD",
        countryName: "Andorra",
        internationalPhonePrefix: "+376",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "AO",
        countryName: "Angola",
        internationalPhonePrefix: "+244",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AI",
        countryName: "Anguilla",
        internationalPhonePrefix: "+1-264",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "AQ",
        countryName: "Antarctica",
        internationalPhonePrefix: "+672",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AG",
        countryName: "Antigua and Barbuda",
        internationalPhonePrefix: "+1-268",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "AR",
        countryName: "Argentina",
        internationalPhonePrefix: "+54",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "AM",
        countryName: "Armenia",
        internationalPhonePrefix: "+374",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "AW",
        countryName: "Aruba",
        internationalPhonePrefix: "+297",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "AU",
        countryName: "Australia",
        internationalPhonePrefix: "+61",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AT",
        countryName: "Austria",
        internationalPhonePrefix: "+43",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "AZ",
        countryName: "Azerbaijan",
        internationalPhonePrefix: "+994",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "BS",
        countryName: "Bahamas",
        internationalPhonePrefix: "+1-242",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "BH",
        countryName: "Bahrain",
        internationalPhonePrefix: "+973",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "BD",
        countryName: "Bangladesh",
        internationalPhonePrefix: "+880",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "BB",
        countryName: "Barbados",
        internationalPhonePrefix: "+1-246",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "BY",
        countryName: "Belarus",
        internationalPhonePrefix: "+375",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "BE",
        countryName: "Belgium",
        internationalPhonePrefix: "+32",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "BZ",
        countryName: "Belize",
        internationalPhonePrefix: "+501",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "BJ",
        countryName: "Benin",
        internationalPhonePrefix: "+229",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "BM",
        countryName: "Bermuda",
        internationalPhonePrefix: "+1-441",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "BT",
        countryName: "Bhutan",
        internationalPhonePrefix: "+975",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "BO",
        countryName: "Bolivia",
        internationalPhonePrefix: "+591",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "BQ",
        countryName: "Bonaire",
        internationalPhonePrefix: "+599",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "BA",
        countryName: "Bosnia and Herzegovina",
        internationalPhonePrefix: "+387",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "BW",
        countryName: "Botswana",
        internationalPhonePrefix: "+267",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "BV",
        countryName: "Bouvet Island",
        internationalPhonePrefix: "+55",
        minLength: 11,
        maxLength: 11,
    },
    {
        countryCode: "BR",
        countryName: "Brazil",
        internationalPhonePrefix: "+55",
        minLength: 10,
        maxLength: 11,
    },
    {
        countryCode: "IO",
        countryName: "British Indian Ocean Territory",
        internationalPhonePrefix: "+246",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "BN",
        countryName: "Brunei Darussalam",
        internationalPhonePrefix: "+673",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "BG",
        countryName: "Bulgaria",
        internationalPhonePrefix: "+359",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "BF",
        countryName: "Burkina Faso",
        internationalPhonePrefix: "+226",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "BI",
        countryName: "Burundi",
        internationalPhonePrefix: "+257",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "CV",
        countryName: "Cabo Verde",
        internationalPhonePrefix: "+238",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "KH",
        countryName: "Cambodia",
        internationalPhonePrefix: "+855",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "CM",
        countryName: "Cameroon",
        internationalPhonePrefix: "+237",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "KY",
        countryName: "Cayman Islands",
        internationalPhonePrefix: "+1-345",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "CF",
        countryName: "Central African Republic",
        internationalPhonePrefix: "+236",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "TD",
        countryName: "Chad",
        internationalPhonePrefix: "+235",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "CL",
        countryName: "Chile",
        internationalPhonePrefix: "+56",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "CN",
        countryName: "China",
        internationalPhonePrefix: "+86",
        minLength: 11,
        maxLength: 11,
    },
    {
        countryCode: "CX",
        countryName: "Christmas Island",
        internationalPhonePrefix: "+61",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "CC",
        countryName: "Cocos (Keeling) Islands",
        internationalPhonePrefix: "+61",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "CO",
        countryName: "Colombia",
        internationalPhonePrefix: "+57",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "KM",
        countryName: "Comoros",
        internationalPhonePrefix: "+269",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "CK",
        countryName: "Cook Islands",
        internationalPhonePrefix: "+682",
        minLength: 5,
        maxLength: 5,
    },
    {
        countryCode: "CR",
        countryName: "Costa Rica",
        internationalPhonePrefix: "+506",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "CI",
        countryName: "Cote d'Ivoire",
        internationalPhonePrefix: "+225",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "HR",
        countryName: "Croatia",
        internationalPhonePrefix: "+385",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "CW",
        countryName: "Curacao",
        internationalPhonePrefix: "+599",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "CY",
        countryName: "Cyprus",
        internationalPhonePrefix: "+357",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "CZ",
        countryName: "Czechia",
        internationalPhonePrefix: "+420",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "DK",
        countryName: "Denmark",
        internationalPhonePrefix: "+45",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "DJ",
        countryName: "Djibouti",
        internationalPhonePrefix: "+253",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "DM",
        countryName: "Dominica",
        internationalPhonePrefix: "+1-767",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "DO",
        countryName: "Dominican Republic",
        internationalPhonePrefix: "+1-809",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "EC",
        countryName: "Ecuador",
        internationalPhonePrefix: "+593",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "EG",
        countryName: "Egypt",
        internationalPhonePrefix: "+20",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "SV",
        countryName: "El Salvador",
        internationalPhonePrefix: "+503",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "GQ",
        countryName: "Equatorial Guinea",
        internationalPhonePrefix: "+240",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "ER",
        countryName: "Eritrea",
        internationalPhonePrefix: "+291",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "EE",
        countryName: "Estonia",
        internationalPhonePrefix: "+372",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "ET",
        countryName: "Ethiopia",
        internationalPhonePrefix: "+251",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "FK",
        countryName: "Falkland Islands",
        internationalPhonePrefix: "+500",
        minLength: 5,
        maxLength: 5,
    },
    {
        countryCode: "FO",
        countryName: "Faroe Islands",
        internationalPhonePrefix: "+298",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "FJ",
        countryName: "Fiji",
        internationalPhonePrefix: "+679",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "FI",
        countryName: "Finland",
        internationalPhonePrefix: "+358",
        minLength: 7,
        maxLength: 12,
    },
    {
        countryCode: "FR",
        countryName: "France",
        internationalPhonePrefix: "+33",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "GF",
        countryName: "French Guiana",
        internationalPhonePrefix: "+594",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PF",
        countryName: "French Polynesia",
        internationalPhonePrefix: "+689",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "TF",
        countryName: "French Southern Territories and Antarctic Lands",
        internationalPhonePrefix: "+262",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "GA",
        countryName: "Gabon",
        internationalPhonePrefix: "+241",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "GM",
        countryName: "Gambia",
        internationalPhonePrefix: "+220",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "GE",
        countryName: "Georgia",
        internationalPhonePrefix: "+995",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "DE",
        countryName: "Germany",
        internationalPhonePrefix: "+49",
        minLength: 10,
        maxLength: 11,
    },
    {
        countryCode: "GH",
        countryName: "Ghana",
        internationalPhonePrefix: "+233",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "GI",
        countryName: "Gibraltar",
        internationalPhonePrefix: "+350",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "GR",
        countryName: "Greece",
        internationalPhonePrefix: "+30",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "GL",
        countryName: "Greenland",
        internationalPhonePrefix: "+299",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "GD",
        countryName: "Grenada",
        internationalPhonePrefix: "+1-473",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "GP",
        countryName: "Guadeloupe",
        internationalPhonePrefix: "+590",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "GU",
        countryName: "Guam",
        internationalPhonePrefix: "+1-671",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "GT",
        countryName: "Guatemala",
        internationalPhonePrefix: "+502",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "GG",
        countryName: "Guernsey",
        internationalPhonePrefix: "+44-1481",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "GN",
        countryName: "Guinea",
        internationalPhonePrefix: "+224",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "GW",
        countryName: "Guinea-Bissau",
        internationalPhonePrefix: "+245",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "GY",
        countryName: "Guyana",
        internationalPhonePrefix: "+592",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "HT",
        countryName: "Haiti",
        internationalPhonePrefix: "+509",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "HM",
        countryName: "Heard Island and McDonald Islands",
        internationalPhonePrefix: "+61",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "VA",
        countryName: "Holy See (Vatican City State)",
        internationalPhonePrefix: "+379",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "HN",
        countryName: "Honduras",
        internationalPhonePrefix: "+504",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "HK",
        countryName: "Hong Kong",
        internationalPhonePrefix: "+852",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "HU",
        countryName: "Hungary",
        internationalPhonePrefix: "+36",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "IS",
        countryName: "Iceland",
        internationalPhonePrefix: "+354",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "IN",
        countryName: "India",
        internationalPhonePrefix: "+91",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "ID",
        countryName: "Indonesia",
        internationalPhonePrefix: "+62",
        minLength: 10,
        maxLength: 11,
    },
    {
        countryCode: "IE",
        countryName: "Ireland",
        internationalPhonePrefix: "+353",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "IM",
        countryName: "Isle of Man",
        internationalPhonePrefix: "+44-1624",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "IL",
        countryName: "Israel",
        internationalPhonePrefix: "+972",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "IT",
        countryName: "Italy",
        internationalPhonePrefix: "+39",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "JM",
        countryName: "Jamaica",
        internationalPhonePrefix: "+1-876",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "JP",
        countryName: "Japan",
        internationalPhonePrefix: "+81",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "JE",
        countryName: "Jersey",
        internationalPhonePrefix: "+44-1534",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "JO",
        countryName: "Jordan",
        internationalPhonePrefix: "+962",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "KZ",
        countryName: "Kazakhstan",
        internationalPhonePrefix: "+7",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "KE",
        countryName: "Kenya",
        internationalPhonePrefix: "+254",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "KI",
        countryName: "Kiribati",
        internationalPhonePrefix: "+686",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "KW",
        countryName: "Kuwait",
        internationalPhonePrefix: "+965",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "KG",
        countryName: "Kyrgyzstan",
        internationalPhonePrefix: "+996",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "LA",
        countryName: "Lao People's Democratic Republic",
        internationalPhonePrefix: "+856",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "LV",
        countryName: "Latvia",
        internationalPhonePrefix: "+371",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "LB",
        countryName: "Lebanon",
        internationalPhonePrefix: "+961",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "LS",
        countryName: "Lesotho",
        internationalPhonePrefix: "+266",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "LR",
        countryName: "Liberia",
        internationalPhonePrefix: "+231",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "LY",
        countryName: "Libya",
        internationalPhonePrefix: "+218",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "LI",
        countryName: "Liechtenstein",
        internationalPhonePrefix: "+423",
        minLength: 7,
        maxLength: 9,
    },
    {
        countryCode: "LT",
        countryName: "Lithuania",
        internationalPhonePrefix: "+370",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "LU",
        countryName: "Luxembourg",
        internationalPhonePrefix: "+352",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MO",
        countryName: "Macao",
        internationalPhonePrefix: "+853",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MK",
        countryName: "Macedonia",
        internationalPhonePrefix: "+389",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MG",
        countryName: "Madagascar",
        internationalPhonePrefix: "+261",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MW",
        countryName: "Malawi",
        internationalPhonePrefix: "+265",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MY",
        countryName: "Malaysia",
        internationalPhonePrefix: "+60",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MV",
        countryName: "Maldives",
        internationalPhonePrefix: "+960",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "ML",
        countryName: "Mali",
        internationalPhonePrefix: "+223",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MT",
        countryName: "Malta",
        internationalPhonePrefix: "+356",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MQ",
        countryName: "Martinique",
        internationalPhonePrefix: "+596",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MR",
        countryName: "Mauritania",
        internationalPhonePrefix: "+222",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MU",
        countryName: "Mauritius",
        internationalPhonePrefix: "+230",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "YT",
        countryName: "Mayotte",
        internationalPhonePrefix: "+269",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MX",
        countryName: "Mexico",
        internationalPhonePrefix: "+52",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "FM",
        countryName: "Micronesia",
        internationalPhonePrefix: "+691",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "MD",
        countryName: "Moldova",
        internationalPhonePrefix: "+373",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MC",
        countryName: "Monaco",
        internationalPhonePrefix: "+377",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MN",
        countryName: "Mongolia",
        internationalPhonePrefix: "+976",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "ME",
        countryName: "Montenegro",
        internationalPhonePrefix: "+382",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "MS",
        countryName: "Montserrat",
        internationalPhonePrefix: "+1-664",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "MA",
        countryName: "Morocco",
        internationalPhonePrefix: "+212",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MZ",
        countryName: "Mozambique",
        internationalPhonePrefix: "+258",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "MM",
        countryName: "Myanmar",
        internationalPhonePrefix: "+95",
        minLength: 7,
        maxLength: 10,
    },
    {
        countryCode: "NA",
        countryName: "Namibia",
        internationalPhonePrefix: "+264",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "NR",
        countryName: "Nauru",
        internationalPhonePrefix: "+674",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "NP",
        countryName: "Nepal",
        internationalPhonePrefix: "+977",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "NL",
        countryName: "Netherlands",
        internationalPhonePrefix: "+31",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AN",
        countryName: "Netherlands Antilles",
        internationalPhonePrefix: "+599",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "NC",
        countryName: "New Caledonia",
        internationalPhonePrefix: "+687",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "NZ",
        countryName: "New Zealand",
        internationalPhonePrefix: "+64",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "NI",
        countryName: "Nicaragua",
        internationalPhonePrefix: "+505",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "NE",
        countryName: "Niger",
        internationalPhonePrefix: "+227",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "NG",
        countryName: "Nigeria",
        internationalPhonePrefix: "+234",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "NU",
        countryName: "Niue",
        internationalPhonePrefix: "+683",
        minLength: 4,
        maxLength: 4,
    },
    {
        countryCode: "NF",
        countryName: "Norfolk Island",
        internationalPhonePrefix: "+672",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "MP",
        countryName: "Northern Mariana Islands",
        internationalPhonePrefix: "+1-670",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "NO",
        countryName: "Norway",
        internationalPhonePrefix: "+47",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "OM",
        countryName: "Oman",
        internationalPhonePrefix: "+968",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "PK",
        countryName: "Pakistan",
        internationalPhonePrefix: "+92",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "PW",
        countryName: "Palau",
        internationalPhonePrefix: "+680",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "PS",
        countryName: "Palestine, State of",
        internationalPhonePrefix: "+970",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PA",
        countryName: "Panama",
        internationalPhonePrefix: "+507",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "PG",
        countryName: "Papua New Guinea",
        internationalPhonePrefix: "+675",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "PY",
        countryName: "Paraguay",
        internationalPhonePrefix: "+595",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PE",
        countryName: "Peru",
        internationalPhonePrefix: "+51",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PH",
        countryName: "Philippines",
        internationalPhonePrefix: "+63",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "PN",
        countryName: "Pitcairn",
        internationalPhonePrefix: "+64",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "PL",
        countryName: "Poland",
        internationalPhonePrefix: "+48",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PT",
        countryName: "Portugal",
        internationalPhonePrefix: "+351",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PR",
        countryName: "Puerto Rico",
        internationalPhonePrefix: "+1",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "QA",
        countryName: "Qatar",
        internationalPhonePrefix: "+974",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "RE",
        countryName: "Reunion",
        internationalPhonePrefix: "+262",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "RO",
        countryName: "Romania",
        internationalPhonePrefix: "+40",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "RU",
        countryName: "Russian Federation",
        internationalPhonePrefix: "+7",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "RW",
        countryName: "Rwanda",
        internationalPhonePrefix: "+250",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "SH",
        countryName: "Saint Helena",
        internationalPhonePrefix: "+290",
        minLength: 4,
        maxLength: 4,
    },
    {
        countryCode: "KN",
        countryName: "Saint Kitts and Nevis",
        internationalPhonePrefix: "+1-869",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "LC",
        countryName: "Saint Lucia",
        internationalPhonePrefix: "+1-758",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "MF",
        countryName: "Saint Martin",
        internationalPhonePrefix: "+590",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "PM",
        countryName: "Saint Pierre and Miquelon",
        internationalPhonePrefix: "+508",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "WS",
        countryName: "Samoa",
        internationalPhonePrefix: "+685",
        minLength: 5,
        maxLength: 5,
    },
    {
        countryCode: "SM",
        countryName: "San Marino",
        internationalPhonePrefix: "+378",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "ST",
        countryName: "Sao Tome and Principe",
        internationalPhonePrefix: "+239",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "SA",
        countryName: "Saudi Arabia",
        internationalPhonePrefix: "+966",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "SN",
        countryName: "Senegal",
        internationalPhonePrefix: "+221",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "RS",
        countryName: "Serbia",
        internationalPhonePrefix: "+381",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "YU",
        countryName: "Serbia and Montenegro",
        internationalPhonePrefix: "+381",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "SC",
        countryName: "Seychelles",
        internationalPhonePrefix: "+248",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "SL",
        countryName: "Sierra Leone",
        internationalPhonePrefix: "+232",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "SG",
        countryName: "Singapore",
        internationalPhonePrefix: "+65",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "SX",
        countryName: "Sint Maarten",
        internationalPhonePrefix: "+1721",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "SK",
        countryName: "Slovakia",
        internationalPhonePrefix: "+421",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "SI",
        countryName: "Slovenia",
        internationalPhonePrefix: "+386",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "SB",
        countryName: "Solomon Islands",
        internationalPhonePrefix: "+677",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "SO",
        countryName: "Somalia",
        internationalPhonePrefix: "+252",
        minLength: 7,
        maxLength: 9,
    },
    {
        countryCode: "ZA",
        countryName: "South Africa",
        internationalPhonePrefix: "+27",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "KR",
        countryName: "South Korea",
        internationalPhonePrefix: "+82",
        minLength: 9,
        maxLength: 11,
    },
    {
        countryCode: "ES",
        countryName: "Spain",
        internationalPhonePrefix: "+34",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "LK",
        countryName: "Sri Lanka",
        internationalPhonePrefix: "+94",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "VC",
        countryName: "St Vincent and Grenadines",
        internationalPhonePrefix: "+1-784",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "SR",
        countryName: "Suriname",
        internationalPhonePrefix: "+597",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "SZ",
        countryName: "Swaziland",
        internationalPhonePrefix: "+268",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "SE",
        countryName: "Sweden",
        internationalPhonePrefix: "+46",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "CH",
        countryName: "Switzerland",
        internationalPhonePrefix: "+41",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "TW",
        countryName: "Taiwan",
        internationalPhonePrefix: "+886",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "TJ",
        countryName: "Tajikistan",
        internationalPhonePrefix: "+992",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "TZ",
        countryName: "Tanzania, United Republic of",
        internationalPhonePrefix: "+255",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "TH",
        countryName: "Thailand",
        internationalPhonePrefix: "+66",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "TL",
        countryName: "Timor-Leste",
        internationalPhonePrefix: "+670",
        minLength: 7,
        maxLength: 8,
    },
    {
        countryCode: "TG",
        countryName: "Togo",
        internationalPhonePrefix: "+228",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "TK",
        countryName: "Tokelau",
        internationalPhonePrefix: "+690",
        minLength: 4,
        maxLength: 4,
    },
    {
        countryCode: "TO",
        countryName: "Tonga",
        internationalPhonePrefix: "+676",
        minLength: 5,
        maxLength: 7,
    },
    {
        countryCode: "TT",
        countryName: "Trinidad and Tobago",
        internationalPhonePrefix: "+1-868",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "TN",
        countryName: "Tunisia",
        internationalPhonePrefix: "+216",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "TR",
        countryName: "Turkey",
        internationalPhonePrefix: "+90",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "TM",
        countryName: "Turkmenistan",
        internationalPhonePrefix: "+993",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "TC",
        countryName: "Turks and Caicos Islands",
        internationalPhonePrefix: "+1-649",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "TV",
        countryName: "Tuvalu",
        internationalPhonePrefix: "+688",
        minLength: 5,
        maxLength: 5,
    },
    {
        countryCode: "UG",
        countryName: "Uganda",
        internationalPhonePrefix: "+256",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "UA",
        countryName: "Ukraine",
        internationalPhonePrefix: "+380",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "AE",
        countryName: "United Arab Emirates",
        internationalPhonePrefix: "+971",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "UM",
        countryName: "United States Minor Outlying Islands",
        internationalPhonePrefix: "+1",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "UY",
        countryName: "Uruguay",
        internationalPhonePrefix: "+598",
        minLength: 8,
        maxLength: 8,
    },
    {
        countryCode: "UZ",
        countryName: "Uzbekistan",
        internationalPhonePrefix: "+998",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "VU",
        countryName: "Vanuatu",
        internationalPhonePrefix: "+678",
        minLength: 7,
        maxLength: 7,
    },
    {
        countryCode: "VE",
        countryName: "Venezuela",
        internationalPhonePrefix: "+58",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "VN",
        countryName: "Viet Nam",
        internationalPhonePrefix: "+84",
        minLength: 9,
        maxLength: 10,
    },
    {
        countryCode: "VG",
        countryName: "Virgin Islands (British)",
        internationalPhonePrefix: "+1-284",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "VI",
        countryName: "Virgin Islands (U.S.)",
        internationalPhonePrefix: "+1-340",
        minLength: 10,
        maxLength: 10,
    },
    {
        countryCode: "WF",
        countryName: "Wallis and Futuna",
        internationalPhonePrefix: "+681",
        minLength: 6,
        maxLength: 6,
    },
    {
        countryCode: "YE",
        countryName: "Yemen",
        internationalPhonePrefix: "+967",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "ZM",
        countryName: "Zambia",
        internationalPhonePrefix: "+260",
        minLength: 9,
        maxLength: 9,
    },
    {
        countryCode: "ZW",
        countryName: "Zimbabwe",
        internationalPhonePrefix: "+263",
        minLength: 9,
        maxLength: 9,
    },
];
export default numberList;
